export const MAX_SHIPPINGS_PER_BATCH = 500;
